export { isDeepEqual } from "./is-deep-equal.ts";
export { isRecord } from "./is-record.ts";
